var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCnc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.7rem",
    height: "2.7rem",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#695346",
    d: "M0 0v24h24V0H8.004Zm3.431 3.431h4.544l.029.023l4.544 4.544h3.03l-4.572-4.567h9.569v9.563l-.789-.782l-3.784-3.79v3.03l2.271 2.272l2.272 2.272l.029.03v4.543h-4.55l-.023-.023l-2.272-2.278l-2.272-2.272h-3.03l3.785 3.79l.782.783H3.43v-9.563l4.573 4.567v-3.031l-4.55-4.544l-.023-.023Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnc);
export default __webpack_public_path__ + "static/media/cnc.66f4810e70f14f1c4d95e46c7ab0a832.svg";
export { ForwardRef as ReactComponent };